import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { getSrcsetUrl, getSrcsetString } from 'dibs-interiors-photos/exports/srcSet';
import { trackPhotoClick } from 'dibs-interiors-photos/exports/trackingHelpers';
import ProjectPhotoLikeWrapper from './ProjectPhotoLikeWrapper';
import classnames from 'classnames';
import { useServerVars } from '../shared/ServerVarsContext';

import { type ProjectPhoto_tradePhoto$key } from './__generated__/ProjectPhoto_tradePhoto.graphql';

import styles from './ProjectPhoto.scss';

const DEFAULT_IMAGE_WIDTH = 720;
const IMG_SIZES = '50vw';

type ProjectPhotoProps = {
    isCoverPhoto?: boolean;
    className?: string;
    tradePhoto: ProjectPhoto_tradePhoto$key | null | undefined;
    openModal: (currentUrl: string) => void;
};

const ProjectPhoto: FC<ProjectPhotoProps> = ({
    isCoverPhoto,
    className,
    openModal,
    tradePhoto: tradePhotoRef,
}) => {
    const tradePhoto = useFragment(
        graphql`
            fragment ProjectPhoto_tradePhoto on TradePhoto {
                path
                url
                ...ProjectPhotoLikeWrapper_tradePhoto
            }
        `,
        tradePhotoRef
    );

    const { isMobile } = useServerVars();

    const photoUrl = tradePhoto?.url || '';
    const photoPath = tradePhoto?.path || '';

    const onPhotoClick = (): void => {
        trackPhotoClick({ label: 'project' });
        openModal(photoUrl);
    };

    return (
        <div
            className={classnames(styles.wrapper, className)}
            onClick={onPhotoClick}
            onKeyPress={onPhotoClick}
            tabIndex={0}
            role="button"
        >
            <img
                src={getSrcsetUrl(photoPath, DEFAULT_IMAGE_WIDTH)}
                srcSet={getSrcsetString(photoPath)}
                sizes={IMG_SIZES}
                className={classnames(styles.image, { [styles.isCover]: isCoverPhoto })}
                alt=""
            />
            <div className={isMobile ? styles.fixedHeight : ''}>
                <ProjectPhotoLikeWrapper tradePhoto={tradePhoto} />
            </div>
        </div>
    );
};

export default ProjectPhoto;
